import { useQuery } from '@tanstack/react-query';
import { useTenant } from '../../../contexts/TenantContext';
import useErrorHandler from '../../../hooks/useErrorHandler';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';

export const GUESTS_QUERY_KEY = ['guests'];

// Every guest at once: a tenant has a few hundred at most, and the page searches them in the browser.
const useGetGuests = () => {
  const { tenantId } = useTenant();
  const { handleError } = useErrorHandler();

  const fetchGuests = async () => {
    try {
      const response = await apiClient.get(`/v1/tenants/${tenantId}/guests`);
      return response.data;
    } catch (error) {
      handleError(error, Routes.DASHBOARD_GUESTS);
      throw error;
    }
  };

  return useQuery({
    queryKey: GUESTS_QUERY_KEY,
    queryFn: fetchGuests,
    enabled: !!tenantId,
  });
};

export default useGetGuests;
